import React from 'react';
import PropTypes from 'prop-types';

// Component
import SessionHandler from '../../contactUs/containers/SessionHandler';
import HeroModuleSession from '../../contactUs/containers/HeroModule';
import ContactOptionsLinksFooter from '../../contactUs/components/ContactOptionsLinksFooter';
import AlertsContainer from '../../contactUs/containers/Alerts';

// Container
import NavHome from '../containers/NavHome';
import ModalContainer from '../../contactUs/containers/ModalContainer';
import ChatInEligibleModalContainer from '../../contactUs/containers/ChatInEligibilityModalContainer';

const App = (props) => {
  const { sideBar, mainContainer } = props;

  const sidebarEl = (
    <div className="side-bar side-bar__grid">
      { sideBar }
    </div>
  );

  const mainContainerEl = (
    <div id="main-container" className="main-container main-container__grid" tabIndex="0" aria-label="">
      <div className="main-container-contents">
        { mainContainer }
      </div>
    </div>
  );

  return (
    <div className="vx_mainContent">
      <SessionHandler />
      <HeroModuleSession />
      <div className="page-main-container" role="main">
        <AlertsContainer />
        <NavHome />
        <ModalContainer FPTITrackerId="articleintermediatePage" />
        <ChatInEligibleModalContainer />
        <div className="page-body-container">
          {sidebarEl} {mainContainerEl}
        </div>
        <ContactOptionsLinksFooter />
      </div>
    </div>
  );
};

App.propTypes = {
  sideBar: PropTypes.element.isRequired,
  mainContainer: PropTypes.element.isRequired,
};

export default App;
